import { UrlMatcher, UrlSegment } from '@angular/router';

export const langUrlMatcher: UrlMatcher = (segments: UrlSegment[]) => {
  return ['de', 'it', 'fr', 'en'].includes(segments[0]?.toString())
    ? { consumed: segments.slice(0, 1), posParams: { lang: segments[0] } }
    : null;
};
